import { state as init } from "../../GlobalState";
import * as actions from "./actions";

const reducer = (state = init, action) => {
  switch (action.type) {
    case actions.SET_IMAGES: {
      return { ...state, loading: false, images: action.payload };
    }
    case actions.SET_ERROR: {
      return { ...state, loading: false, error: action.payload };
    }

    default:
      return state;
  }
};

export default reducer;
